import { defineStore } from 'pinia'

export const useBrowseStateStore = defineStore('browseState', {
    state: () => ({
        // 首页状态
        home: {
            // 滚动位置
            scrollPosition: 0,
            // 筛选状态
            filters: {
                searchQuery: '',
                selectedCategoryId: null,
                selectedTagIds: [],
            },
            // 显示状态
            showAllTags: false,
            // 最后更新时间
            lastUpdated: null
        },

        // 当前页面信息（用于调试）
        currentPage: {
            name: 'Home',
            params: {},
            timestamp: Date.now()
        }
    }),

    getters: {
        // 获取首页滚动位置
        homeScrollPosition: (state) => state.home.scrollPosition,

        // 获取首页筛选状态
        homeFilters: (state) => state.home.filters,

        // 检查是否有保存的状态
        hasHomeState: (state) => state.home.lastUpdated !== null
    },

    actions: {
        /**
         * 保存首页状态
         * @param {Object} homeState 首页状态对象
         */
        saveHomeState(homeState) {
            this.home = {
                ...this.home,
                ...homeState,
                lastUpdated: Date.now()
            }

            console.log('💾 保存首页状态:', {
                scrollPosition: this.home.scrollPosition,
                filters: this.home.filters,
                showAllTags: this.home.showAllTags
            })
        },

        /**
         * 保存滚动位置
         * @param {number} position 滚动位置
         */
        saveScrollPosition(position) {
            this.home.scrollPosition = position
            this.home.lastUpdated = Date.now()
            console.log(`📍 保存滚动位置: ${position}px`)
        },

        /**
         * 保存筛选状态
         * @param {Object} filters 筛选状态
         */
        saveFilters(filters) {
            this.home.filters = { ...filters }
            this.home.lastUpdated = Date.now()
            console.log('🔍 保存筛选状态:', filters)
        },

        /**
         * 保存标签展开状态
         * @param {boolean} showAllTags 是否显示所有标签
         */
        saveTagsExpandState(showAllTags) {
            this.home.showAllTags = showAllTags
            this.home.lastUpdated = Date.now()
            console.log(`🏷️ 保存标签展开状态: ${showAllTags}`)
        },

        /**
         * 获取首页状态
         * @returns {Object} 首页状态
         */
        getHomeState() {
            if (!this.hasHomeState) {
                return null
            }

            console.log('📖 恢复首页状态:', {
                scrollPosition: this.home.scrollPosition,
                filters: this.home.filters,
                showAllTags: this.home.showAllTags
            })

            return { ...this.home }
        },

        /**
         * 清除首页状态
         */
        clearHomeState() {
            this.home = {
                scrollPosition: 0,
                filters: {
                    searchQuery: '',
                    selectedCategoryId: null,
                    selectedTagIds: [],
                },
                showAllTags: false,
                lastUpdated: null
            }
            console.log('🗑️ 清除首页状态')
        },

        /**
         * 设置当前页面
         * @param {Object} pageInfo 当前页面信息
         */
        setCurrentPage(pageInfo) {
            this.currentPage = {
                ...pageInfo,
                timestamp: Date.now()
            }
        },



        /**
 * 智能清理状态
 * 在特定条件下清理过期的状态
 */
        smartCleanup() {
            const now = Date.now()
            const oneHour = 60 * 60 * 1000 // 1小时

            // 如果首页状态超过1小时，清除
            if (this.home.lastUpdated && (now - this.home.lastUpdated) > oneHour) {
                console.log('⏰ 首页状态已过期，自动清理')
                this.clearHomeState()
            }
        },

        /**
 * 应用滚动恢复
 * @param {number} position 目标滚动位置
 * @param {number} delay 延迟时间(ms)，默认10ms
 */
        applyDelayedScrollRestore(position, delay = 10) {
            if (position <= 0) {
                return
            }

            console.log(`📍 恢复滚动位置: ${position}px`)

            // 立即恢复，减少闪烁
            setTimeout(() => {
                window.scrollTo({
                    top: position,
                    behavior: 'auto' // 立即滚动，不使用平滑动画
                })

                console.log(`✅ 滚动位置已恢复到: ${position}px`)
            }, delay)
        }
    }
}) 